import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-4 py-10 text-center text-teal-700 dark:text-gray-200" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-4xl" }, " There was an error displaying this Page. Please try again later. ")
], -1)

import { useRouter } from 'vue-router';
import store from '@/store';
import { Routes, StoreActions } from '@/constants';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

const resetErrorCode = () => {
  if (store.getters.homebuyerId) {
    store.dispatch(StoreActions.SET_ERROR_CODE, -1);
    router.push({ name: Routes.DASHBOARD });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "btn m-3 text-sm mt-8",
        onClick: resetErrorCode
      }, " Go To Home Page ")
    ])
  ]))
}
}

})